<div class="register-container">
  <div class="edit-profile-container">
    <h2>Editar perfil</h2>

    <!-- Campo de Banner -->
    <div class="banner-section">
      <div class="banner-container">
        <img [src]="profile.imgBanner || 'assets/default-banner.png'" alt="Banner" />
        <label for="fileInputBanner" class="edit-icon banner-edit-icon">
          <i class="fas fa-pencil-alt"></i>
        </label>
        <input type="file" id="fileInputBanner" class="hidden-file" (change)="onBannerImageSelected($event)" />
      </div>
    </div>

    <!-- Campo de Foto de Perfil -->
    <div class="profile-header">
      <div class="profile-photo-section">
        <img [src]="profile.imgPerfil || 'assets/default-avatar.png'" alt="Foto de perfil" />
        <label for="fileInputProfile" class="edit-icon">
          <i class="fas fa-pencil-alt"></i>
        </label>
        <input type="file" id="fileInputProfile" class="hidden-file" (change)="onProfileImageSelected($event)" />
      </div>

      <div class="username-section">
        <label>
          Usuario
          <input type="text" [(ngModel)]="profile.username" name="username" placeholder="Nombre de usuario" />
        </label>
      </div>
    </div>

    <!-- Formulario -->
    <form (ngSubmit)="onSubmit()" class="form-fields">
      <label>
        Email
        <input type="email" [(ngModel)]="profile.email" name="email" placeholder="Correo electrónico" />
      </label>

      <label>
        Nacionalidad
        <input type="text" [(ngModel)]="profile.nacionalidad" name="nacionalidad" placeholder="Nacionalidad" />
      </label>

      <label>
        Facebook
        <input type="text" [(ngModel)]="profile.facebook" name="facebook" placeholder="https://facebook.com" />
      </label>

      <label>
        Twitter
        <input type="text" [(ngModel)]="profile.twitter" name="twitter" placeholder="https://twitter.com" />
      </label>

      <label>
        Instagram
        <input type="text" [(ngModel)]="profile.instagram" name="instagram" placeholder="https://instagram.com" />
      </label>

      <button type="submit" class="save-button">Guardar cambios</button>
    </form>
  </div>
</div>